import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/set/jxcstore/list', qs.stringify(params))
}

//获取工厂明细
export const getDetail = (params) => {
  return axios.get(root+'/set/jxcstore/edit', {params:params})
}

//获取不需要过滤独立核算部门
export const getListDataall = (params) => {
  return axios.post(root+'/set/jxcstore/listall', qs.stringify(params))
}

//获取需要过滤独立核算部门
export const getListDatabyinpd = (params) => {
  return axios.post(root+'/set/jxcstore/listbyipd', qs.stringify(params))
}

export const thirdStore = (params) => {
  return axios.post(root+'/set/jxcstore/thirdStore', qs.stringify(params))
}


//删除行
export const deleteData = (params) => {
  return axios.post(root+'/set/jxcstore/remove',  qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root+'/set/jxcstore/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/jxcstore/save', qs.stringify(params))
  }
}
//根据登录人过滤仓库
export const cusandptbyind = (params) => {
  return axios.post(root+'/set/jxcstore/cusandptbyind', qs.stringify(params))
}

export const initMonth= () => {
  return axios.post(root+'/warehouse/store/initMonth', null)
}




// WEBPACK FOOTER //
// ./src/api/set/jxcstore.js